import React, {useState, useEffect, useRef, useCallback} from "react";
import {GoogleMap, useJsApiLoader, Marker} from '@react-google-maps/api';
import {getCurrentGeo} from "../Components/utils";
import {IonSpinner} from '@ionic/react';

const libraries = ['places'];

const GoogleMapWrapper = ({
                              location,
                              marker = null,
                              width = '100%',
                              height = '100%',
                              style = {},
                              zoom = 3,
                              modes = false,
                              callback = () => {
                              }
                          }) => {

    const defaultOption = {
        panControl: true,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        clickableIcons: true,
        keyboardShortcuts: false,
        scrollwheel: modes,
        disableDoubleClickZoom: false,
        fullscreenControl: true,
    };

    const defaultCenter = location ? location : {
        lat: 57.8642403,
        lng: 63.9506995
    };

    const [center, setCenter] = useState(null);
    const [positionMarker, setPositionMarker] = useState(marker);
    const [mapZoom, setMapZoom] = useState(zoom);

    const {isLoaded} = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyCbPeSWvAD0LTeMJFuKl5K-az1W3rheIGI",
        libraries
    });

    const mapRef = useRef(undefined);

    const onLoad = useCallback(function callback(map) {
        mapRef.current = map;
    }, []);

    const onUnmount = useCallback(function callback(map) {
        mapRef.current = undefined;
    }, []);

    const getBrowserLocation = () => {
        return new Promise((resolve, reject) => {
            getCurrentGeo().then(data => {
                if (data) {
                    const result = {
                        lat: data.coords.latitude,
                        lng: data.coords.longitude
                    };
                    resolve(result);
                } else {
                    reject(defaultCenter);
                }
            }, err => {
                reject(defaultCenter);
            })
        })

    };

    useEffect(() => {
        if (modes) {
            getBrowserLocation().then((curloc) => {
                setCenter(curloc);
                setPositionMarker(curloc);
                callback(curloc);
                setMapZoom(10);
            }).catch((defaultLocation) => {
                setCenter(defaultLocation);
            });
        } else {
            setCenter(defaultCenter);
        }
    }, []);

    const setMarker = (loc) => {
        if (modes) {
            const lat = loc.latLng.lat();
            const lng = loc.latLng.lng();
            setPositionMarker({lat, lng});
            callback({lat, lng});
        }
    }

    return isLoaded && center ?
        (
            <GoogleMap
                mapContainerStyle={{width, height, ...style}}
                center={center}
                zoom={mapZoom}
                onLoad={onLoad}
                onUnmount={onUnmount}
                options={defaultOption}
                onClick={setMarker}
            >
                {positionMarker && <Marker position={positionMarker}/>}
            </GoogleMap>
        ) :
        <div className='loader-center' style={{width, height}}>
            <IonSpinner name="lines" />
        </div>
}


export default React.memo(GoogleMapWrapper);
